export interface IPrice {
  priceId: string;
  currency: string;
  description: string | null;
  product: IProduct;
  accountId: string;
  metadata: { [key: string]: string };
  unitAmount: number;
  active: boolean;
  type: PriceType;
  recurring?: IRecurringPrice;
}

export class DummyPrice {
  public static createDummyPrice(priceId: string, accountId: string): IPrice {
    return {
      priceId,
      accountId,
      currency: '-',
      description: null,
      metadata: {},
      active: true,
      product: {
        id: '',
        metadata: {},
        name: '',
      },
      type: 'recurring',
      unitAmount: 0,
      recurring: {
        interval: '',
      },
    };
  }
}

export type PriceType = 'one_time' | 'recurring';

export enum ProductCategory {
  Goods ='goods',
  Services = 'services',
}

interface IRecurringPrice {
  interval: string;
}

export interface IProduct {
  id: string;
  name: string;
  metadata: IMetadata;
}

interface IMetadata {
  [name: string]: string;
}
